import { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { IntercomAPI } from '@webapp/api/IntercomAPI'
import {
  makeSelectDomain,
  makeSelectRole,
  makeSelectUser,
} from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { INTERCOM_APP_ID } from '@webapp/infrastructure/envs'
import { PermissionGroupNames } from '@webapp/platform/_unmigrated/models/PermissionGroups'
import { IntercomContainerStyled } from './styles/IntercomContainer'
import { IntercomMessengerPositionStyled } from './styles/IntercomMessengerPositionStyled'

export const Intercom = () => {
  const FT_4880_ENABLE_INTERCOM = useFeatureFlag('FT_4880_ENABLE_INTERCOM')
  const DES_162_INTERCOM_TOPBAR_LAUNCHER = useFeatureFlag(
    'DES_162_INTERCOM_TOPBAR_LAUNCHER'
  )
  const user = useSelector(makeSelectUser())
  const domain = useSelector(makeSelectDomain())
  const role = useSelector(makeSelectRole())

  const [intercomUserHash, setIntercomUserHash] = useState<string>(null)

  useEffect(() => {
    IntercomAPI.getIntercomUserHash()
      .then((res) => {
        if (res?.data?.user_hash) {
          setIntercomUserHash(res.data.user_hash)
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  useEffect(() => {
    if (
      FT_4880_ENABLE_INTERCOM &&
      window?.Intercom &&
      intercomUserHash &&
      role &&
      PermissionGroupNames.SITE_ADMINISTRATOR !== role.name
    ) {
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: INTERCOM_APP_ID,
        email: user.email,
        user_hash: intercomUserHash,
        name: `${user.firstName} ${user.lastName}`,
        domain,
        role: role.name,
        company: {
          name: domain,
          id: domain,
        },
        is_superuser:
          PermissionGroupNames.SITE_ADMINISTRATOR === role.name ||
          PermissionGroupNames.SUPERUSER === role.name,
        hide_default_launcher: DES_162_INTERCOM_TOPBAR_LAUNCHER,
      })
    }
  }, [
    FT_4880_ENABLE_INTERCOM,
    DES_162_INTERCOM_TOPBAR_LAUNCHER,
    user.email,
    role,
    domain,
    intercomUserHash,
  ])

  if (
    FT_4880_ENABLE_INTERCOM &&
    role &&
    PermissionGroupNames.SITE_ADMINISTRATOR !== role.name
  ) {
    return DES_162_INTERCOM_TOPBAR_LAUNCHER ? (
      <IntercomMessengerPositionStyled />
    ) : (
      <IntercomContainerStyled />
    )
  }
  return null
}
